import { CART_REVAMP_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {string} payload.page_type - The page type where the event is triggered
 * @param {string} payload.product_id - The product ID of the impressed product
 */
export const onTrackProductImpression = async ({ page_type, product_id }) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_REVAMP_TRACKER_TYPE.ProductImpression,
    data: { page_type, product_id },
  });
};
